<template>
  <div class="session-header">
    <div class="session-title-group">
      <h3 class="session-title">
        Session {{ sessionNumber }} — {{ sessionTitle }}
      </h3>
      <button
        v-if="hasDescription"
        @click="$emit('toggle-description')"
        class="session-info-button"
        title="Voir la description"
      >
        <i class="fas fa-info-circle"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionHeader',
  props: {
    sessionNumber: {
      type: [Number, String],
      required: true
    },
    sessionTitle: {
      type: String,
      required: true
    },
    exerciseCount: {
      type: Number,
      required: true,
      default: 0,
    },
    hasDescription: {
      type: Boolean,
      default: false
    },
    isDescriptionVisible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.session-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0 8px 0;
  border-bottom: 1px solid #e2e8f0;
  width: 100%;
}

.session-title-group {
  display: flex;
  align-items: center;
  gap: 12px;
}

.session-title {
  font-size: 1.15rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.01em;
}

.session-info-button {
  background: transparent;
  border: none;
  color: #94a3b8;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.session-info-button:hover {
  color: #239380;
  background: #f1f5f9;
}

@media (max-width: 768px) {
  .session-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}
</style>
